import "react-datepicker/dist/react-datepicker.css";
import Sidebar from "../../../components/Navigation/Sidebar";
import Topbar from "../../../components/Navigation/Topbar";
import { HeaderSubCategories } from "./components/HeaderSubCategories";
import { ContentSubCategories } from "./components/ContentSubCategories";

const SubCategories = () => {
  return (
    <div>
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Topbar />
            <div className="container-fluid">
              <HeaderSubCategories />
              <ContentSubCategories />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubCategories;
